export const getPresetRangeEpoch = (days: number, now: Date = new Date()): { fromEpoch: number; toEpoch: number } => {
  const toDate = new Date(now.getTime());
  toDate.setHours(23, 59, 59, 999);

  const fromDate = new Date(toDate.getTime());
  fromDate.setDate(fromDate.getDate() - (days - 1));
  fromDate.setHours(0, 0, 0, 0);

  return {
    fromEpoch: Math.floor(fromDate.getTime() / 1000),
    toEpoch: Math.floor(toDate.getTime() / 1000),
  };
};
